import React, { useState, useEffect } from "react";
import { Checkbox, FormControlLabel } from "@material-ui/core";
import "./LineTypeSettings.css";
import Changes from "../../common/Changes";

export default function LineTypeSettings({ LineType, UpdateLineType }) {
  const [lineType, setLineType] = useState(LineType);

  const handleUpdate = (event, key, value) => {
    LineType[key] = event ? event.target.value : value;
    UpdateLineType(LineType);
  };
  const handleChange = (event, key, value) => {
    setLineType({
      ...LineType,
      [key]: event ? event.target.value : value,
    });
  };

  useEffect(() => {
    setLineType(LineType);
  }, [LineType, setLineType]);

  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center justify-between">
        <h2>Link Type Synch</h2>
        <Changes
          title="Line Type Synch"
          params={{
            ChangeType: 12,
            IdSport: "",
            Param1: lineType.idLineType,
            Param2: 0,
            Param3: 0,
          }}
        />
      </div>
      <div className="grid grid-cols-3 gap-4">
        <div className="flex flex-col gap-4">
          <div className="!gap-0 vertical-options">
            <h3>Football / Basketball</h3>
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={lineType.fbbbSpreadSync}
                  onChange={(event) => {
                    handleChange(undefined, "fbbbSpreadSync", event.target.checked);
                    handleUpdate(undefined, "fbbbSpreadSync", event.target.checked);
                  }}
                  color="primary"
                />
              }
              label="Point Spread"
            />
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={lineType.fbbbSpreadOddsSync}
                  onChange={(event) => {
                    handleChange(undefined, "fbbbSpreadOddsSync", event.target.checked);
                    handleUpdate(undefined, "fbbbSpreadOddsSync", event.target.checked);
                  }}
                  color="primary"
                />
              }
              label="Point Spread Odds"
            />
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={lineType.fbbbTotalSync}
                  onChange={(event) => {
                    handleChange(undefined, "fbbbTotalSync", event.target.checked);
                    handleUpdate(undefined, "fbbbTotalSync", event.target.checked);
                  }}
                  color="primary"
                />
              }
              label="Total"
            />
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={lineType.fbbbTotalOddsSync}
                  onChange={(event) => {
                    handleChange(undefined, "fbbbTotalOddsSync", event.target.checked);
                    handleUpdate(undefined, "fbbbTotalOddsSync", event.target.checked);
                  }}
                  color="primary"
                />
              }
              label="Over/Under Odds"
            />
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={lineType.fbbbMoneyLineSync}
                  onChange={(event) => {
                    handleChange(undefined, "fbbbMoneyLineSync", event.target.checked);
                    handleUpdate(undefined, "fbbbMoneyLineSync", event.target.checked);
                  }}
                  color="primary"
                />
              }
              label="Money Line"
            />
          </div>
          <div className="!gap-0 vertical-options">
            <h3>Baseball</h3>
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={lineType.mlbMoneyLineSync}
                  onChange={(event) => {
                    handleChange(undefined, "mlbMoneyLineSync", event.target.checked);
                    handleUpdate(undefined, "mlbMoneyLineSync", event.target.checked);
                  }}
                  color="primary"
                />
              }
              label="Money Line"
            />
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={lineType.mlbTotalSync}
                  onChange={(event) => {
                    handleChange(undefined, "mlbTotalSync", event.target.checked);
                    handleUpdate(undefined, "mlbTotalSync", event.target.checked);
                  }}
                  color="primary"
                />
              }
              label="Total"
            />
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={lineType.mlbTotalOddsSync}
                  onChange={(event) => {
                    handleChange(undefined, "mlbTotalOddsSync", event.target.checked);
                    handleUpdate(undefined, "mlbTotalOddsSync", event.target.checked);
                  }}
                  color="primary"
                />
              }
              label="Over/Under Odds"
            />
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={lineType.mlbRunSync}
                  onChange={(event) => {
                    handleChange(undefined, "mlbRunSync", event.target.checked);
                    handleUpdate(undefined, "mlbRunSync", event.target.checked);
                  }}
                  color="primary"
                />
              }
              label="Run Line"
            />
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={lineType.mlbRunOddsSync}
                  onChange={(event) => {
                    handleChange(undefined, "mlbRunOddsSync", event.target.checked);
                    handleUpdate(undefined, "mlbRunOddsSync", event.target.checked);
                  }}
                  color="primary"
                />
              }
              label="Run Line Odds"
            />
          </div>
        </div>
        <div className="flex flex-col gap-4">
          <div className="!gap-0 vertical-options">
            <h3>Hockey</h3>
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={lineType.nhlMoneyLineSync}
                  onChange={(event) => {
                    handleChange(undefined, "nhlMoneyLineSync", event.target.checked);
                    handleUpdate(undefined, "nhlMoneyLineSync", event.target.checked);
                  }}
                  color="primary"
                />
              }
              label="Money Line"
            />
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={lineType.nhlTotalSync}
                  onChange={(event) => {
                    handleChange(undefined, "nhlTotalSync", event.target.checked);
                    handleUpdate(undefined, "nhlTotalSync", event.target.checked);
                  }}
                  color="primary"
                />
              }
              label="Total"
            />
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={lineType.nhlTotalOddsSync}
                  onChange={(event) => {
                    handleChange(undefined, "nhlTotalOddsSync", event.target.checked);
                    handleUpdate(undefined, "nhlTotalOddsSync", event.target.checked);
                  }}
                  color="primary"
                />
              }
              label="Over/Under Odds"
            />
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={lineType.nhlCanadianSync}
                  onChange={(event) => {
                    handleChange(undefined, "nhlCanadianSync", event.target.checked);
                    handleUpdate(undefined, "nhlCanadianSync", event.target.checked);
                  }}
                  color="primary"
                />
              }
              label="Canadian Line"
            />
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={lineType.nhlCanadianOddsSync}
                  onChange={(event) => {
                    handleChange(undefined, "nhlCanadianOddsSync", event.target.checked);
                    handleUpdate(undefined, "nhlCanadianOddsSync", event.target.checked);
                  }}
                  color="primary"
                />
              }
              label="Canadian Line Odds"
            />
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={lineType.nhlAmericanSync}
                  onChange={(event) => {
                    handleChange(undefined, "nhlAmericanSync", event.target.checked);
                    handleUpdate(undefined, "nhlAmericanSync", event.target.checked);
                  }}
                  color="primary"
                />
              }
              label="American Line"
            />
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={lineType.nhlAmericanOddsSync}
                  onChange={(event) => {
                    handleChange(undefined, "nhlAmericanOddsSync", event.target.checked);
                    handleUpdate(undefined, "nhlAmericanOddsSync", event.target.checked);
                  }}
                  color="primary"
                />
              }
              label="American Line Odds"
            />
          </div>
        </div>
        <div className="flex flex-col gap-4">
          <div className="!gap-0 vertical-options">
            <h3>Soccer</h3>
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={lineType.socMoneyLineSync}
                  onChange={(event) => {
                    handleChange(undefined, "socMoneyLineSync", event.target.checked);
                    handleUpdate(undefined, "socMoneyLineSync", event.target.checked);
                  }}
                  color="primary"
                />
              }
              label="Money Line"
            />
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={lineType.socTotalSync}
                  onChange={(event) => {
                    handleChange(undefined, "socTotalSync", event.target.checked);
                    handleUpdate(undefined, "socTotalSync", event.target.checked);
                  }}
                  color="primary"
                />
              }
              label="Total"
            />
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={lineType.socTotalOddsSync}
                  onChange={(event) => {
                    handleChange(undefined, "socTotalOddsSync", event.target.checked);
                    handleUpdate(undefined, "socTotalOddsSync", event.target.checked);
                  }}
                  color="primary"
                />
              }
              label="Over/Under Odds"
            />
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={lineType.socGoalsSync}
                  onChange={(event) => {
                    handleChange(undefined, "socGoalsSync", event.target.checked);
                    handleUpdate(undefined, "socGoalsSync", event.target.checked);
                  }}
                  color="primary"
                />
              }
              label="Goals"
            />
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={lineType.socGoalsOddsSync}
                  onChange={(event) => {
                    handleChange(undefined, "socGoalsOddsSync", event.target.checked);
                    handleUpdate(undefined, "socGoalsOddsSync", event.target.checked);
                  }}
                  color="primary"
                />
              }
              label="Goals Odds"
            />
          </div>
          <div className="!gap-0 vertical-options">
            <h3>Matchups</h3>
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={lineType.muMoneyLineSync}
                  onChange={(event) => {
                    handleChange(undefined, "muMoneyLineSync", event.target.checked);
                    handleUpdate(undefined, "muMoneyLineSync", event.target.checked);
                  }}
                  color="primary"
                />
              }
              label="Money Line"
            />
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={lineType.muTotalSync}
                  onChange={(event) => {
                    handleChange(undefined, "muTotalSync", event.target.checked);
                    handleUpdate(undefined, "muTotalSync", event.target.checked);
                  }}
                  color="primary"
                />
              }
              label="Total"
            />
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={lineType.muTotalOddsSync}
                  onChange={(event) => {
                    handleChange(undefined, "muTotalOddsSync", event.target.checked);
                    handleUpdate(undefined, "muTotalOddsSync", event.target.checked);
                  }}
                  color="primary"
                />
              }
              label="Over/Under Odds"
            />
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={lineType.muSpreadSync}
                  onChange={(event) => {
                    handleChange(undefined, "muSpreadSync", event.target.checked);
                    handleUpdate(undefined, "muSpreadSync", event.target.checked);
                  }}
                  color="primary"
                />
              }
              label="Point Spread"
            />
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={lineType.muSpreadOddsSync}
                  onChange={(event) => {
                    handleChange(undefined, "muSpreadOddsSync", event.target.checked);
                    handleUpdate(undefined, "muSpreadOddsSync", event.target.checked);
                  }}
                  color="primary"
                />
              }
              label="Point Spread Odds"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
